import { SettingsList } from '../SettingsLIst'

import { HelpAndSupport } from './HelpAndSupport'

export const Support = () => (
  <SettingsList>
    <HelpAndSupport />
  </SettingsList>
)
